
import { Accordion, AccordionDetails, AccordionSummary, Card, Grid, Typography, TextField, styled, Select, Box, FormControlLabel } from '@mui/material';
import { CommonButton, CommonOutlinedButton, CustomCalendarTodayOutlinedIcon, CustomCheckbox, CustomDatePicker, CustomDownIcon, CustomInputLabel, CustomRequiredInputLabel, CustomTextFeild, CustomTextFeildforFamily, CustomTimeOutlinedIcon, CustomTimePicker, CustomUpIcon, StyledDateContainer } from '../../common/StyledComponents/StyledFields';
import styles from '../../contactUs/contactus.module.scss';
import { useEffect, useState } from 'react';
import { object, string, ValidationError } from 'yup';
import { isEmpty } from 'lodash';
import {
  LocalizationProvider,
  PickerChangeHandlerContext,
  TimeValidationError,
} from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import InputAdornment from "@mui/material/InputAdornment";
import dayjs from "dayjs";
import { DietiesListByPoojaIdProps } from '../../../infrastructure/GlobalContextProvider';
import { apiRequest } from '../../../infrastructure/backendService';
import apiPath from "../../../config/apiPaths.json";
import { ClipLoader } from 'react-spinners';
import HcccTimePicker from '../../common/customTimePicker/hcccTimePicker';
import ButtonLoader from '../../common/ButtonLoader/ButtonLoader';


interface ErrorMessageTypes {
  pooja: string;
  poojaDateFrom: string;
  poojaTimeFrom: string;
  poojaDateTo: string;
  poojaTimeTo: string;
  //deities: string;
}

const ArchanaReport = ({ sendDataToParent, getReportData }:any) => {
  const [dietyError, setDietyError] = useState('');
  const [allDieties, setAllDieties] = useState<boolean>(false);
  const [donationCartItems, setDonationCartItems] = useState<string[]>([]);
  const [formData, setFormData] = useState({
    pooja: 'Ashtottara Archana',
    poojaDateFrom: dayjs().format("MM-DD-YYYY"),
    poojaTimeFrom: '',
    poojaDateTo: dayjs().format("MM-DD-YYYY"),
    poojaTimeTo: '',
    // deities: '',
  });
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState<ErrorMessageTypes>({
    pooja: '',
    poojaDateFrom: '',
    poojaTimeFrom: '',
    poojaDateTo: '',
    poojaTimeTo: '',
    // deities: '',

  });
  const validationSchema = object().shape({
    pooja: string().required('Pooja Name is required'),
    poojaDateFrom: string().required('Pooja Start Date is required'),
    // poojaTimeFrom: string().required('Pooja Start Time is required'),
    poojaDateTo: string().required('Phone End Date is required'),
    // poojaTimeTo: string().required('Pooja End Time is required'),
    // deities: string().required('Deitie is required'),

  });

  const [poojaDeitiesList, setPoojaDeitiesList] = useState<
        DietiesListByPoojaIdProps[]
    >([]);

  useEffect(() => {
    apiRequest({
      method: "GET",
      endpoint: apiPath.deitiesListByPoojaId,
      includeToken: true,
      params: {
        poojaId: 54,
      },
    })
      .then((res) => {
        setPoojaDeitiesList(res.data);
      })
      .catch((err) => {
        console.log(err);
      })
    }, []);

    const getArchanaReports = () => {
      let dieties = donationCartItems.join(",");
      let poojaId = 54; 
      if (allDieties) {
        dieties = "ALL";
        poojaId = 52; 
      }
      
    if (donationCartItems.length === 0  && !allDieties){
      setDietyError("Deity is Mandatory,Please Select Deity.");
    } else {
      const reqBody = {
        fromDate: formData.poojaDateFrom,
        toDate: formData.poojaDateTo,
        poojaId: poojaId,
        deityName:dieties
      };
      setLoading(true);
      apiRequest({
          method: "POST",
          endpoint: '/report-dashboard/reports/abhishekam/ARCHANA_REPORTS/browser',
          body: JSON.stringify(reqBody),
          includeToken:true
        })
        .then((res) => {
          setLoading(false);
          sendDataToParent(true,reqBody,formData);
          // getReportData(res.data);
          const response = res.data.map((report:any)=>{
            return {
              ...report,
              userinfo:report.userinfo.map((userInfo:any)=>{
                return {
                  "Pooja Date":userInfo.poojadate,
                  username:userInfo.username,
                  gothram:userInfo.gothram,
                  nakshtram:userInfo.nakshtram,
                  ...userInfo
                  
                }
              })
            }
          })
          getReportData(response);
        })
        .catch((err) => {
          setLoading(false);
        })
      }
  };

  const handleSave = async (): Promise<any> => {

    const errors: ErrorMessageTypes = {
      pooja: '',
      poojaDateFrom: '',
      poojaTimeFrom: '',
      poojaDateTo: '',
      poojaTimeTo: '',
      //deities: '',
    };
    try {
      // Validate the form data against the validation schema
      await validationSchema.validate(formData, { abortEarly: false });
      // If validation passes, you can submit the form
      setErrorMessage(errors);
      // Call your API or perform other actions here
      //  saveApiCall();
      getArchanaReports();

    } catch (error) {
      // Handle validation errors

      if (error instanceof ValidationError) {
        error.inner.forEach((e) => {
          if (e.path) {
            errors[e.path as keyof ErrorMessageTypes] = e.message;
          }
        });
      }
      setErrorMessage(errors);
    }
  };

  // const handleAccordionChange = () => {
  //   setAccordionExpanded((prevExpanded) => !prevExpanded);
  // };

  const handleFieldChange = (field: any, value: any) => {
    setFormData({
      ...formData,
      [field]: value,
    });
  };

  const handleCheckboxChange = (deityName: string) => {
    const isSelected = donationCartItems.includes(deityName);
    setDietyError("");
    if (isSelected) {
      setDonationCartItems(donationCartItems.filter((item) => item !== deityName));
    } else {
      setDonationCartItems([...donationCartItems, deityName]);
    }
  };

  const handleDateChange = (field: keyof ErrorMessageTypes, value: any) => {
    const formattedDate = dayjs(value, "MM-DD-YYYY");
    // setCurrentItem((prevItem) => ({ ...prevItem, [field]: formattedDate.isValid() ? formattedDate.format('MM-DD-YYYY') : '' }));
    setFormData({
      ...formData,
      [field]: formattedDate.isValid()
        ? formattedDate.format("MM-DD-YYYY")
        : "",
    });
  };

  const handleAllDeitiesChange = (event: any) => {
    const isChecked = event.target.checked;
    setAllDieties(isChecked);
    setDietyError("");
  };


  const deities = () => {
    return (
      <div>
        {CustomRequiredInputLabel("Deities", true)}
        <div className={styles.deitiesContainer}>
          {poojaDeitiesList.map((item, index) => (
            <Box key={index} className={styles.singleBox}>
              <Box sx={{ display: "flex", alignItems: "center" }} className={styles.checkTitle}>
                <FormControlLabel
                  control={
                    <CustomCheckbox
                      size="medium"
                      className={styles.checkbox}
                      checked={donationCartItems.includes(item.deityName)}
                      onChange={() => handleCheckboxChange(item.deityName)}
                    />
                  }
                  label=""
                />
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    marginLeft: "-4px",
                  }}
                  className={styles.textradio}
                >
                  <Typography className={styles.textStyles}>
                    {item.deityName}
                  </Typography>
                  {/* {radioButtons()} */}
                </Box>
              </Box>
            </Box>
          ))}
        </div>
      </div>
    );
  };


  const poojaStartDatePicker = (): React.ReactElement => {
    return (
      <div style={{ minWidth: "100%", borderRadius: "8px" }}>
        <StyledDateContainer
          sx={{
            backgroundColor: "#fff",
            borderRadius: "8px",
            height: "48px",
          }}
        >
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DateTimePicker"]}>
              <CustomDatePicker
                slots={{
                  openPickerIcon: CustomCalendarTodayOutlinedIcon,
                }}
                slotProps={{
                  inputAdornment: {
                    position: "end",
                  },
                }}
                format="MM-DD-YYYY"
                value={
                  formData.poojaDateFrom
                    ? dayjs(formData.poojaDateFrom, "MM-DD-YYYY")
                    : ""
                }
                onChange={(value) => {
                  setErrorMessage({ ...errorMessage, poojaDateFrom: "" });
                  handleDateChange("poojaDateFrom", value);
                }}
                className={
                  errorMessage.poojaDateFrom
                    ? styles.errorTextField
                    : styles.textField
                }
              />
            </DemoContainer>
          </LocalizationProvider>
          {errorMessage.poojaDateFrom ? (
            <Typography sx={{ color: "red", fontSize: "12px" }}>
              {errorMessage.poojaDateFrom}
            </Typography>
          ) : (
            ""
          )}
        </StyledDateContainer>
      </div>
    );
  };

  const poojaEndDatePicker = (): React.ReactElement => {
    return (
      <div style={{ minWidth: "100%", borderRadius: "8px" }}>
        <StyledDateContainer
          sx={{
            backgroundColor: "#fff",
            borderRadius: "8px",
            height: "48px",
          }}
        >
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DateTimePicker"]}>
              <CustomDatePicker
                slots={{
                  openPickerIcon: CustomCalendarTodayOutlinedIcon,
                }}
                slotProps={{
                  inputAdornment: {
                    position: "end",
                  },
                }}
                format="MM-DD-YYYY"
                value={
                  formData.poojaDateTo
                    ? dayjs(formData.poojaDateTo, "MM-DD-YYYY")
                    : ""
                }
                onChange={(value) => {
                  setErrorMessage({ ...errorMessage, poojaDateTo: "" });
                  handleDateChange("poojaDateTo", value);
                }}
                className={
                  errorMessage.poojaDateTo
                    ? styles.errorTextField
                    : styles.textField
                }
              />
            </DemoContainer>
          </LocalizationProvider>
          {errorMessage.poojaDateTo ? (
            <Typography sx={{ color: "red", fontSize: "12px" }}>
              {errorMessage.poojaDateTo}
            </Typography>
          ) : (
            ""
          )}
        </StyledDateContainer>
      </div>
    );
  };

  const handleClear = () => {
    setFormData({
      pooja: 'Ashtottara Archana',
      poojaDateFrom: '',
      poojaTimeFrom: '',
      poojaDateTo: '',
      poojaTimeTo: '',
      // deities: '',
    });
  }

  const [isDatePickerFromOpen, setDatePickerFromOpen] = useState(false);
  const [isDatePickerToOpen, setDatePickeToOpen] = useState(false);

  useEffect(() => {
    setDatePickerFromOpen(false);
  }, [formData.poojaDateFrom]);

  useEffect(() => {
    setDatePickeToOpen(false);
  }, [formData.poojaDateTo]);

  return (
    <div className={styles.abhishekamReportsMainContainer}>
      <Grid container spacing={2}>
        <Grid xs={12} sm={3} item>
          {CustomRequiredInputLabel("Pooja", true)}
          <CustomTextFeildforFamily
            fullWidth
            required
            disabled
            value={formData.pooja}
            onChange={(e) => {
              setErrorMessage({ ...errorMessage, pooja: "" });
              handleFieldChange("firstName", e.target.value);
            }}
            className={
              !isEmpty(errorMessage.pooja)
                ? styles.errorTextField
                : styles.textField
            }
          />
          {!isEmpty(errorMessage.pooja) && (
            <Typography sx={{ color: "red", fontSize: "12px" }}>
              {errorMessage.pooja}
            </Typography>
          )}
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid xs={12} sm={3} item>
          {CustomRequiredInputLabel("Pooja Date From", true)}
          {poojaStartDatePicker()}
        </Grid>
        <Grid xs={12} sm={3} item>
          <HcccTimePicker
              handleFieldChange={handleFieldChange}
              labelName="Pooja Time From"
              fieldName="poojaTimeFrom"
              isLabelNotRequired={true}
              className={
                errorMessage.poojaTimeFrom
                  ? styles.errorTextField
                  : styles.textFieldTime
              }
              value={formData.poojaTimeFrom}
            />
        </Grid>
      </Grid>
      <Grid container spacing={2} sx={{ marginTop: "10px" }}>
        <Grid xs={12} sm={3} item>
          {CustomRequiredInputLabel("Pooja Date To", true)}
          {poojaEndDatePicker()}
        </Grid>
        <Grid xs={12} sm={3} item>
          <HcccTimePicker
              handleFieldChange={handleFieldChange}
              labelName="Pooja Time To"
              fieldName="poojaTimeTo"
              isLabelNotRequired={true}
              className={
                errorMessage.poojaTimeTo
                  ? styles.errorTextField
                  : styles.textFieldTime
              }
              value={formData.poojaTimeTo}
            />
        </Grid>
      </Grid>
      <Grid container spacing={2} sx={{ marginTop: "10px" }}>
        <Grid xs={12} item>
          {deities()}
        </Grid>
        <Grid xs={12} item sx={{ display: "flex", gap: "16px" }}>
          <FormControlLabel
            control={
              <CustomCheckbox
                checked={allDieties}
                onChange={handleAllDeitiesChange}
              />
            }
            label="All Deities"
            sx={{
              color: "#000",
              fontSize: "16px",
            }}
          />
        </Grid>
        {!isEmpty(dietyError) ? (
          <Typography sx={{ color: "red", fontSize: "12px",marginLeft:"17px" }}>
            {dietyError}
          </Typography>
        ) : (
          ""
        )}
      </Grid>
      
        <Grid xs={12} item  sx={{ marginTop: "10px", display: "flex", gap: "16px" }}>
        <CommonButton
            sx={{ width: "fit-content", height: "38px" }}
            onClick={handleSave}
            disabled={loading}
            id="submit"
          >
            <ButtonLoader isBtnLoading={loading} btnText={"Submit"} />
          </CommonButton>
          <CommonOutlinedButton onClick={handleClear}>
            Reset
          </CommonOutlinedButton>
        </Grid>
  
    </div>
  );
}

export default ArchanaReport;